"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoSlider = void 0;

var _react = _interopRequireWildcard(require("react"));

var momentjs = _interopRequireWildcard(require("moment"));

var _ = require("../");

require("./VideoSlider.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var VideoSlider = function VideoSlider(_ref) {
  var play = _ref.play,
      pause = _ref.pause,
      jump = _ref.jump,
      fullGameTime = _ref.fullGameTime,
      currentTime = _ref.currentTime,
      offset = _ref.offset,
      duration = _ref.duration,
      onChange = _ref.onChange;

  var _useState = (0, _react.useState)("--:--"),
      _useState2 = _slicedToArray(_useState, 2),
      formattedTime = _useState2[0],
      setFormattedTime = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var _useState5 = (0, _react.useState)(15),
      _useState6 = _slicedToArray(_useState5, 2),
      max = _useState6[0],
      setMax = _useState6[1];

  var _useState7 = (0, _react.useState)(1),
      _useState8 = _slicedToArray(_useState7, 2),
      percent = _useState8[0],
      setPercent = _useState8[1];

  var _useState9 = (0, _react.useState)({}),
      _useState10 = _slicedToArray(_useState9, 2),
      fillStyles = _useState10[0],
      setFillStyles = _useState10[1];

  var onDragStart = function onDragStart(e) {
    console.log(e);
  };

  var onDragEnd = function onDragEnd(e) {
    play();
    (0, _.trackEvent)({
      action: "Video Scrubbed",
      element: e.target
    });
  };

  var scrub = function scrub(e) {
    var val = e.target.value;

    if (val && val !== value) {
      jump(val);
    }
  };

  (0, _react.useEffect)(function () {
    var ft = "--:--";

    if (currentTime) {
      var fgt = fullGameTime ? fullGameTime : 0;
      var t = momentjs.duration((currentTime + fgt) * 1000);
      var minutes = Math.floor(t.asMinutes());
      t.subtract(minutes, "minutes");
      var seconds = Math.floor(t.seconds());
      ft = minutes < 10 ? "0" : "";
      ft += minutes;
      ft += ":";
      ft += seconds < 10 ? "0" : "";
      ft += seconds;

      if (ft !== formattedTime) {
        setFormattedTime(ft);
      }
    }
  }, [currentTime, fullGameTime, momentjs]);
  (0, _react.useEffect)(function () {
    var v = currentTime ? currentTime : 0.1;

    if (v !== value) {
      setValue(v);
    }

    var mx = duration ? duration : 15;

    if (mx !== max) {
      setMax(mx);
    }

    var p = v / mx * 100;

    if (p !== percent) {
      setPercent(p);
      var fs = {
        width: "calc(".concat(p, "%)")
      };
      setFillStyles(fs);
    }
  }, [currentTime, duration, setValue, setMax, setPercent, setFillStyles]);
  return /*#__PURE__*/_react.default.createElement(_.Row, {
    className: "VideoSlider"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    padding: "0 0 0 4",
    className: "current-time",
    type: _.Label.Type.Body,
    color: _.Color.White1,
    small: true
  }, formattedTime), /*#__PURE__*/_react.default.createElement(_.Element, {
    span: "10",
    className: "range"
  }, /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "range-fill",
    style: fillStyles
  }), /*#__PURE__*/_react.default.createElement(_.Element, {
    tag: "input",
    type: "range",
    className: "video-range",
    min: "0",
    step: "0.001",
    value: value,
    max: max,
    onChange: scrub,
    onTouchStart: onDragStart,
    onMouseDown: onDragStart,
    onMouseUp: onDragEnd,
    onTouchEnd: onDragEnd
  })));
};

exports.VideoSlider = VideoSlider;